// extracted by mini-css-extract-plugin
module.exports = {"dropZone":"RoadmapCell_dropZone__2vlTE","item":"RoadmapCell_item__1au88","isDraggingItem":"RoadmapCell_isDraggingItem__2aeng"};